import React,{useState,useRef,useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import CheckoutSteps from "./CheckoutSteps";
import { useSelector, useDispatch } from "react-redux";
import MetaData from '../components/MetaData.js';
import { useAlert } from "react-alert";
import {
  CardNumberElement,
  CardCvcElement,
  CardExpiryElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import axios from "axios";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import EventIcon from "@material-ui/icons/Event";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import { createOrder, clearErrors } from "../actions/orderAction";
import { clearCart } from "../actions/cartAction";
import {setCache,getCache} from './cache.js';
// import ReCAPTCHA from "react-google-recaptcha";

const Payment = () => {

	const orderInfo = JSON.parse(sessionStorage.getItem("orderInfo"));

	const dispatch = useDispatch();
	const navigate = useNavigate();
	const alert = useAlert();
	const stripe = useStripe();
	const elements = useElements();
	const payBtn = useRef(null);

	const { shippingInfo, cartItems } = useSelector((state) => state.cart);
	const { user } = useSelector((state) => state.user);
	const { error } = useSelector((state) => state.newOrder);

	// console.log(cartItems)

	const [currencySymbol, setCurrencySymbol] = useState("£");
  const [countryCode, setCountryCode] = useState("GB");
  const [isLoading, setIsLoading] = useState(false);

  // Country-to-Currency mapping with exchange rates
  // const countryToCurrency = {
  //   PK: { symbol: "₨", rate: 380 },
  //   US: { symbol: "$", rate: 1.2 },
  //   FR: { symbol: "€", rate: 1.15 },
  //   IN: { symbol: "₹", rate: 100 },
  //   GB: { symbol: "£", rate: 1 },
  // };

  const [countryToCurrency, setCountryToCurrency] = useState({
      PK: { symbol: "₨", currencyCode: "PKR", rate: null },
      US: { symbol: "$", currencyCode: "USD", rate: null },
      FR: { symbol: "€", currencyCode: "EUR", rate: null },
      IN: { symbol: "₹", currencyCode: "INR", rate: null },
      GB: { symbol: "£", currencyCode: "GBP", rate: null },
      AE: { symbol: "AED", currencyCode: "AED", rate: null },
      CN: { symbol: "CNY", currencyCode: "CNY", rate: null },
      SA: { symbol: "SAR", currencyCode: "SAR", rate: null },
    });

    const API_URL = "https://open.er-api.com/v6/latest/GBP"; // Replace with your API endpoint

  //   const fetchExchangeRates = async () => {
  //     try {
  //       const response = await fetch(API_URL);
  //       if (!response.ok) throw new Error("Failed to fetch exchange rates");
  //       const data = await response.json();

  //       setCountryToCurrency((prev) => {
  //         const updatedCurrencies = { ...prev };

  //         Object.keys(updatedCurrencies).forEach((country) => {
  //           const currencyCode = updatedCurrencies[country].currencyCode;
  //           const rate = data.rates[currencyCode];
  //           if (rate) {
  //             updatedCurrencies[country].rate = rate;
  //           }
  //         });

  //         return updatedCurrencies;
  //       });
  //     } catch (error) {
  //       console.error("Error fetching exchange rates:", error);
  //     }
  //   };

  //   // Fetch user's country using their IP address
  //   const fetchUserCountry = async () => {
  //   try {
  //     const response = await fetch("https://get.geojs.io/v1/ip/country.json");
  //     if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
  //     const data = await response.json();
  //     return data.country || "GB";
  //   } catch (error) {
  //     console.error("Error fetching user country:", error);
  //     return "GB"; // Default to GB on failure
  //   }
  // };


  //   const loadCurrencyDetails = async () => {
  //   setIsLoading(true);
  //   await fetchExchangeRates();
  //   const userCountry = await fetchUserCountry();
  //   setCountryCode(userCountry);
  //   setCurrencySymbol(countryToCurrency[userCountry]?.symbol || "£");
  //   setIsLoading(false);
  // };

  // useEffect(() => {
  //   loadCurrencyDetails();
  // }, []);

    const CACHE_DURATION = 1 * 10;

    const fetchExchangeRates = async () => {
  const cacheKey = `ExchangeRates:${new Date().toISOString().split('T')[0]}`;
  console.log(`[FETCH] Generated Cache Key: ${cacheKey}`);
  const cachedData = getCache(cacheKey);
  console.log(cachedData)
  if (cachedData) {
    console.log("Exchange rates fetched from cache",new Date());
    return cachedData;
  }

  try {
    const response = await fetch(API_URL);
    if (!response.ok) throw new Error("Failed to fetch exchange rates");

    const data = await response.json();
    setCache(cacheKey, data, CACHE_DURATION);
    console.log("Exchange rates fetched from API");
    return data;
  } catch (error) {
    console.error("Error fetching exchange rates:", error);
    throw error;
  }
};

// Fetch user's country with caching
const fetchUserCountry = async () => {
  const cacheKey = "UserCountry";
  const cachedData = getCache(cacheKey);

  if (cachedData) {
    console.log("User country fetched from cache",new Date());
    return cachedData;
  }

  try {
    const response = await fetch("https://get.geojs.io/v1/ip/country.json");
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

    const data = await response.json();
    const country = data.country || "GB";
    setCache(cacheKey, country, CACHE_DURATION);
    console.log("User country fetched from API");
    return country;
  } catch (error) {
    console.error("Error fetching user country:", error);
    return "GB"; // Default to GB on failure
  }
};

// Load currency details with caching
const loadCurrencyDetails = async () => {
  setIsLoading(true);

  try {
    const exchangeRates = await fetchExchangeRates();
    const userCountry = await fetchUserCountry();

    setCountryToCurrency((prev) => {
      const updatedCurrencies = { ...prev };

      Object.keys(updatedCurrencies).forEach((country) => {
        const currencyCode = updatedCurrencies[country].currencyCode;
        const rate = exchangeRates.rates[currencyCode];
        if (rate) {
          updatedCurrencies[country].rate = rate;
        }
      });

      const currencyInfo = updatedCurrencies[userCountry] || updatedCurrencies["GB"];
      setCurrencySymbol(currencyInfo.symbol || "£");

      return updatedCurrencies;
    });

    setCountryCode(userCountry);
  } catch (error) {
    console.error("Error loading currency details:", error);
  } finally {
    setIsLoading(false);
  }
};

// React useEffect to load data on mount
useEffect(() => {
  loadCurrencyDetails();
}, []);

	const paymentData = {
    	amount: orderInfo.subtotal,
	};

	const order = {
		shippingInfo,
		orderItems: cartItems,
		itemsPrice: orderInfo.subtotal,
		taxPrice: orderInfo.tax,
		shippingPrice: orderInfo.shippingCharges,
		// totalPrice: orderInfo.totalPrice,
		totalPrice: orderInfo.subtotal,
	};
	// console.log(order)
	const submitHandler = async (e) =>{
		e.preventDefault();
		payBtn.current.disabled = true;
		setIsLoading(true);

		try {
	      const config = {
	        headers: {
	          "Content-Type": "application/json",
	        },
	      };
	      const { data } = await axios.post(
	        "/api/v1/payment/process",
	        paymentData,
	        config
	      );

	      const client_secret = data.client_secret;

	      if (!stripe || !elements) return;

	      const result = await stripe.confirmCardPayment(client_secret, {
	        payment_method: {
	          card: elements.getElement(CardNumberElement),
	          billing_details: {
	            name: user.name,
	            email: user.email,
	            address: {
	              line1: shippingInfo.address,
	              city: shippingInfo.city,
	              state: shippingInfo.state,
	              postal_code: shippingInfo.pinCode,
	              country: shippingInfo.country,
	            },
	          },
	        },
	      });

	      if (result.error) {
	        payBtn.current.disabled = false;
	        setIsLoading(false);
	        alert.error(result.error.message);
	      } else {
	        if (result.paymentIntent.status === "succeeded") {
	          order.paymentInfo = {
	            id: result.paymentIntent.id,
	            status: result.paymentIntent.status,
	          };

	          dispatch(createOrder(order));
	          dispatch(clearCart());

	          try {
					    const emailData = {
					      email: user.email,
					      name: user.name,
					      orderId: result.paymentIntent.id,
					      products: cartItems.map((item) => ({
						      name: item.name,
						      topic: item.topic,
						      vat: item.vat,
						      quantity: item.quantity,
						      price: item.price,
						    })),
					    };

					    await axios.post("/api/v1/sendConfirmationEmail", emailData, {
					      headers: {
					        "Content-Type": "application/json",
					      },
					    });

					    navigate("/success");
					  } catch (emailError) {
					    alert.error("Payment succeeded, but failed to send confirmation email.");
					  }
	        } else {
	          alert.error("There's some issue while processing payment ");
	        }
	      }
	    } catch (error) {
	      payBtn.current.disabled = false;
	      alert.error(error.response.data.message);
	    } finally {
      setIsLoading(false); // Reset loading state after process
    }
	}

	useEffect(() => {
		if (error) {
		  alert.error(error);
		  dispatch(clearErrors());
		}
	}, [dispatch, error, alert]);

	// function onChange(value) {
	//   console.log("Captcha value:", value);
	// }

	return (
		<>
			<MetaData title="Payment" />
			<div className="section section-padding update_password">
        	<div className="container">
        	<div className="row">
        		<CheckoutSteps activeStep={2} />
        	</div>
            <div className="row justify-content-center">
	        <div className="col-md-6 col-sm-12">
      		<div className="paymentContainer">
		        <form className="paymentForm" onSubmit={(e) => submitHandler(e)}>
		          <h3>Card Info</h3>
		          <div>
		            <CreditCardIcon />
		            <CardNumberElement className="paymentInput" />
		          </div>
		          <div>
		            <EventIcon />
		            <CardExpiryElement className="paymentInput" />
		          </div>
		          <div>
		            <VpnKeyIcon />
		            <CardCvcElement className="paymentInput" />
		          </div>
		          {/*<ReCAPTCHA
						    sitekey="Your client site key"
						    onChange={onChange}
						  />*/}
		          <input
		            type="submit"
		            value={isLoading ? "Processing..." : `Pay - £${orderInfo && orderInfo.subtotal}`}
                    ref={payBtn}
                    className="btn btn-primary btn-hover-dark paymentFormBtn"
                    disabled={isLoading} // Disable button while loading
		          />
		        </form>
		    </div>
		    </div>
		    </div>
		    </div>
		    </div>
		</>
	)
}

export default Payment